<template>
    <el-container>
        <el-header>
            <el-form :inline="true" :model="fromAlarmGroup" ref="fromAlarmGroup" class="demo-form-inline">
                <td-permission :permissions="permissionsQuery">
                    <div slot="havePermission">
                        <el-form-item :label="$t('common.ALARM_SUBSCRIPTION_NUMBER')" prop="sId" style="padding-left:15px">
                            <td-input v-model="fromAlarmGroup.sId"></td-input>
                        </el-form-item>
                        <el-form-item :label="$t('common.NAME')" prop="sName" style="padding-left:26px">
                            <td-input v-model="fromAlarmGroup.sName"></td-input>
                        </el-form-item>
                        <el-form-item :label="$t('common.DEVICE_TYPE')" prop="sDeviceTypeId">
                            <td-select
                                v-model="fromAlarmGroup.sDeviceTypeId"
                                keys="iId"
                                text="sName"
                                :options="deviceTypeList"
                                :multiple="true"
                                :collapse-tags="true"
                                :placeholder="$t('common.PLEASE_SELECT')"
                            ></td-select>
                        </el-form-item>
                        <el-form-item :label="$t('pgCommon.ALARM_DEVICE')" prop="sDeviceId">
                            <td-tree-select
                                ref="TdDeviceTree"
                                :defaultProps="deviceProps"
                                :lazyloading="deviceLazyload"
                                nodeKey="id"
                                :checkStrictly="false"
                                :isSingleCheck="false"
                                :showBox="true"
                                :inputShow="true"
                                :multiple="true"
                                @isChosen="isChosen"
                                :imgloading="true"
                                :isDistributed="false"
                                @queryData="queryDeviceTreeData"
                                @querySearchData="queryDeviceSearchData"
                                :isPaging="true"
                                :calInternal="false"
                                :params="params"
                                :customProp="customProp"
                                v-model="fromAlarmGroup.sDeviceId"
                                :filter="deviceFilter"
                            ></td-tree-select>
                        </el-form-item>
                        <el-form-item :label="$t('pgCommon.ALARM_GROUP')" prop="sAlarmTypeId">
                            <td-tree-select
                                ref="TdAlarmTypeTree"
                                v-model="fromAlarmGroup.sAlarmTypeId"
                                :treeList="alarmTypeList"
                                :lazyloading="false"
                                :defaultProps="defaultProps"
                                :isSingleCheck="false"
                                :inputShow="true"
                                nodeKey="id"
                                :expandAll="true"
                                :multiple="true"
                            ></td-tree-select>
                        </el-form-item>
                        <el-form-item :label="$t('common.ALARM_TYPE')" prop="sAlarmEventId">
                            <td-select
                                v-model="fromAlarmGroup.sAlarmEventId"
                                :multiple="true"
                                keys="sId"
                                text="sName"
                                :collapse-tags="true"
                                :options="alarmEventList"
                                :placeholder="$t('common.PLEASE_SELECT')"
                            ></td-select>
                        </el-form-item>
                        <el-form-item :label="$t('common.ALARM_LEVEL')" prop="sAlarmLevelId">
                            <td-select
                                v-model="fromAlarmGroup.sAlarmLevelId"
                                keys="sId"
                                text="sName"
                                :options="alarmLevelList"
                                :multiple="true"
                                :collapse-tags="true"
                                :placeholder="$t('common.PLEASE_SELECT')"
                            >
                            </td-select>
                        </el-form-item>
                    </div>
                </td-permission>
                <el-form-item class="paddingLeft10">
                    <td-button type="primary" :permissions="permissionsQuery" @getPermissionsStatus="getPermissionsStatus" :loading="loading" @click="btnClickQuery">{{
                        $t('common.QUERY')
                    }}</td-button>
                    <td-button type="button" :permissions="permissionsAdd" @click="btnAddsubGro">{{ $t('common.ADD') }}</td-button>
                    <td-button type="button" :permissions="permissionsDelete" @click="btnDeleteGroup">{{ $t('common.DELETE') }}</td-button>
                </el-form-item>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                ref="tableInfo"
                :dataSource="tableData"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
                :permissions="permissionsQuery"
                :rowKey="rowKey"
            ></td-table>
            <!-- 加载dialog -->
            <dialog-subscribeGroupInfo
                v-if="dialogsubGroVisible"
                :isAddData="isAddData"
                :dialogsubGroVisible="dialogsubGroVisible"
                :sIdDisabled="sIdDisabled"
                :editItem="editItem"
                :title="title"
                @subGroDialogClose="subGroDialogClose"
                @submit="submit"
                :alarmLevelList="alarmLevelList"
                :deviceTypeList="deviceTypeList"
                :alarmTypeList="alarmTypeList"
                :alarmEventList="alarmEventList"
            ></dialog-subscribeGroupInfo>
        </el-main>
    </el-container>
</template>

<script>
import api from './assets/api.js';
import dialogSubscribeGroupInfo from './components/dialogSubscribeGroupInfo.vue';
export default {
    // 初始化渲染
    components: {
        'dialog-subscribeGroupInfo': dialogSubscribeGroupInfo
    },
    created() {
        api.getAlarmLevel('{}', response => {
            this.alarmLevelList = response.data.content;
        });
        api.getDeviceTypeList('', response => {
            this.deviceTypeList = response.data.content;
        });
        api.getAlarmTypeTree('', response => {
            this.alarmTypeList = response.data.content;
        });
        api.getAlarmEvent({}, response => {
            this.alarmEventList = response.data.content;
        });
    },
    // 定义数据
    data() {
        return {
            triggerDeviceType: [],
            deviceTypeList: [],
            alarmTypeList: [],
            alarmEventList: [],
            alarmLevelList: [],
            customProp: ['noPermission'],
            interfaceName: { query: '/device/queryDeviceOrgTree', search: '/device/queryDeviceOrgTreeByName' },
            params: {
                includeSelf: true, // 查询条件是否包含自己
                parentId: '',
                rootCodes: this.$common.initOrgTreeParam.SCODE,
                orgTypeIds: this.$common.initOrgTreeParam.ORGTYPEIDS
            },
            deviceProps: {
                children: 'children',
                label: 'caption',
                id: 'id',
                imgName: 'sIcon',
                parentId: 'parentId'
            },
            defaultProps: {
                children: 'children',
                label: 'typeName',
                id: 'id'
            },
            deviceFilter: [
                {
                    field: 'device',
                    value: false
                }
            ],
            fromAlarmGroup: { sName: '', sId: '' },
            permissionsQuery: ['alarmSubscribeGroup:view'],
            permissionsAdd: ['alarmSubscribeGroup:add'],
            permissionsDelete: ['alarmSubscribeGroup:del'],
            editItem: '',
            dialogsubGroVisible: false,
            dialogClassifyVisible: false,
            tableData: [],
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            rowKey: 'sId',
            columns: [
                {
                    prop: 'sId',
                    label: this.$t('common.ALARM_SUBSCRIPTION_NUMBER'),
                    tableWidth: '120',
                    showOverflowTooltip: true
                },
                {
                    prop: 'sName',
                    label: this.$t('common.NAME'),
                    tableWidth: '120',
                    showOverflowTooltip: true
                },
                {
                    prop: 'deviceTypeContent',
                    label: this.$t('common.DEVICE_TYPE'),
                    showOverflowTooltip: true
                },
                {
                    prop: 'alarmDeviceContent',
                    label: this.$t('pgCommon.ALARM_DEVICE'),
                    showOverflowTooltip: true
                },
                {
                    prop: 'alarmTypeContent',
                    label: this.$t('pgCommon.ALARM_GROUP'),
                    showOverflowTooltip: true
                },
                {
                    prop: 'alarmEventContent',
                    label: this.$t('common.ALARM_TYPE'),
                    showOverflowTooltip: true
                },
                {
                    prop: 'alarmLevelContent',
                    label: this.$t('common.ALARM_LEVEL'),
                    showOverflowTooltip: true
                },
                {
                    prop: 'sDescribe',
                    label: this.$t('common.DESCRIPTION'),
                    showOverflowTooltip: true
                },
                {
                    prop: 'iStartStatus',
                    label: this.$t('common.START_STATUS'),
                    tableWidth: '60',
                    align: 'center',
                    render: (createElement, params) => {
                        let context = '';
                        if (params.row.iStartStatus === 0) {
                            context = this.$t('common.DISABLE');
                        } else if (params.row.iStartStatus === 1) {
                            context = this.$t('common.ENABLE');
                        }
                        return createElement('span', context);
                    }
                },
                {
                    prop: '',
                    label: this.$t('common.OPERATE'),
                    tableWidth: '90',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: ['alarmSubscribeGroup:edit'] },
                                    on: {
                                        click: () => {
                                            this.btnExit(params.row);
                                        }
                                    }
                                },
                                this.$t('common.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: ['alarmSubscribeGroup:del'] },
                                    on: {
                                        click: () => {
                                            this.btnDelete([params.row.sId]);
                                        }
                                    }
                                },
                                this.$t('common.DELETE')
                            )
                        ]);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.submit();
        },
        getPermissionsStatus(permissions) {
            if (permissions) {
                this.btnQuery(); // 进行页面初始化数据的加载
            }
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.submit();
        },
        //查询点击按钮
        btnClickQuery() {
            this.currentPage = 1;
            this.btnQuery();
        },
        // 查询数据
        btnQuery() {
            this.loading = true;
            let param = {
                sName: this.fromAlarmGroup.sName,
                sId: this.fromAlarmGroup.sId,
                iType: 1,
                sDeviceTypeId: this.fromAlarmGroup.sDeviceTypeId,
                sAlarmEventId: this.fromAlarmGroup.sAlarmEventId,
                sAlarmLevelId: this.fromAlarmGroup.sAlarmLevelId,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                isPage: true
            };
            let sAlarmTypeId = [];
            let alarmTypeNode = this.fromAlarmGroup.sAlarmTypeId;
            if (alarmTypeNode) {
                alarmTypeNode.forEach(element => {
                    sAlarmTypeId.push(element.id);
                });
            }

            let sDeviceId = [];
            let deviceNode = this.fromAlarmGroup.sDeviceId;
            if (deviceNode) {
                deviceNode.forEach(element => {
                    sDeviceId.push(element.sId);
                });
            }
            param.sAlarmTypeId = sAlarmTypeId;
            param.sDeviceId = sDeviceId;

            api.getAlarmSubscribeGroup(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('alarm/getAlarmSubscribeGroup', response.data.statusMessage);
                    this.loading = false;
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });
        },
        queryDeviceTreeData: function(item) {
            //查询报警设备类型
            if (this.triggerDeviceType.length == 0) {
                api.getDeviceTypeList('', response => {
                    let deviceType = response.data.content;
                    if (deviceType) {
                        for (let i = 0; i < deviceType.length; i++) {
                            this.triggerDeviceType.push(deviceType[i].iId);
                        }
                        this.deviceTreeData(item);
                    }
                });
            } else {
                this.deviceTreeData(item);
            }
        },
        //组织设备树
        deviceTreeData: function(item) {
            if (item.parentId === '' || item.parentId === null || item.parentId === undefined) {
                item.parentId = item.parentId = '';
            }
            let queryParam = {
                includeSelf: true, // 查询条件是否包含自己
                parentId: item.parentId,
                rootCodes: this.$common.initOrgTreeParam.SCODE,
                orgTypeIds: this.$common.initOrgTreeParam.ORGTYPEIDS,
                noPermission: item.noPermission,
                deviceTypeList: this.triggerDeviceType,
                currentPage: item.currentPage,
                pageSize: item.pageSize
            };
            api.findDeviceTree(JSON.stringify(queryParam), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/device/queryDeviceOrgTree', response.data.statusMessage);
                    return;
                }
                // 初始化树形数据
                this.$refs.TdDeviceTree.initData(response.data.content);
            });
        },
        queryDeviceSearchData: function(item) {
            //查询报警设备类型
            if (this.triggerDeviceType.length == 0) {
                api.getDeviceTypeList('', response => {
                    let deviceType = response.data.content;
                    if (deviceType) {
                        for (let i = 0; i < deviceType.length; i++) {
                            this.triggerDeviceType.push(deviceType[i].iId);
                        }
                        this.deviceSearchData(item);
                    }
                });
            } else {
                this.deviceSearchData(item);
            }
        },
        //组织设备树查询
        deviceSearchData: function(item) {
            let queryParam = {
                currentPage: item.currentPage,
                pageSize: item.pageSize,
                deviceTypeList: this.triggerDeviceType,
                caption: item.caption
            };
            api.queryDeviceOrgTreeByName(JSON.stringify(queryParam), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/device/queryDeviceOrgTreeByName', response.data.statusMessage);
                    return;
                }
                // 初始化树形数据
                this.$refs.TdDeviceTree.initData(response.data.content);
            });
        },
        // 添加
        btnAddsubGro() {
            this.title = this.$t('common.ADD'); // 标题
            this.isAddData = true;
            this.dialogsubGroVisible = true;
            this.sIdDisabled = false;
        },
        // 编辑
        btnExit(row) {
            this.editItem = row;
            this.title = this.$t('common.EDIT');
            this.isAddData = false;
            this.dialogsubGroVisible = true;
            this.sIdDisabled = true;
        },
        // 获取选中表格数据的id
        getTableSelectId() {
            let selectData = this.$refs.tableInfo.getSelectAllRows();
            let tableId = [];
            for (let i = 0; i < selectData.length; i++) {
                tableId.push(selectData[i].sId);
            }
            return tableId;
        },
        // 批量删除
        btnDeleteGroup() {
            let tableId = this.getTableSelectId();
            if (tableId.length === 0) {
                this.$message({ showClose: true, message: this.$t('common.PLEASE_SELECT'), type: 'warning' });
                return;
            }
            this.btnDelete(tableId);
        },
        // 删除接口
        btnDelete(sId) {
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    api.deleteAlarmSubscribeGroup(JSON.stringify(sId), response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('alarm/deleteAlarmSubscribeGroup', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('common.DELETE_SUCCESS'), type: 'success' });
                        this.submit();
                    });
                })
                .catch(() => {});
        },
        // 组件关闭需要调用的方法
        submit() {
            this.btnQuery();
        },
        // 关闭页面
        subGroDialogClose() {
            this.dialogsubGroVisible = false;
        },
        // 设备下拉选择时执行的方法
        isChosen(data) {
            this.$refs.TdDeviceTree.isSelect(data.device);
            if (!data.device) {
                this.$message({ showClose: true, message: this.$t('common.PLEASE_CHOOSE_DEVICE_NODE'), type: 'warning' });
            }
        }
    }
};
</script>
